import { render, staticRenderFns } from "@/views/RedeemVoucherTpl.vue?vue&type=template&id=243f3636&"
import script from "./RedeemVoucher.vue?vue&type=script&lang=js&"
export * from "./RedeemVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports